import React, {useState} from "react";
import {Button, Card, CardContent, Grid, Typography} from "@material-ui/core";
import {usePackagesStyles} from "./useStyles";
import PackageUpdateCaution from "./PackageUpdateCaution";
import {fetchDetails} from "../../actions/billingAction";
import {useDispatch} from "react-redux";
import {getUserBillingInformation} from "../../api/billingApi";
import Utils from "../../helpers/Utils";

const MAX_VISIBLE_FEATURES = 4;
const BILLING_TYPE_OLD = 'OLD';
const BILLING_TYPE_NEW = 'NEW';

const PackageItem = ({ plan }) => {
    const dispatch = useDispatch();
    const classes = usePackagesStyles();
    const [showAll, setShowAll] = useState(false);
    const [showCautionAlert, setShowCautionAlert] = useState(false);
    const [gettingStated, setGettingStarted] = useState(false);

    const toggleShowAll = () => {
        setShowAll(prev => !prev);
    };

    const visibleFeatures = showAll ? plan.features : plan.features.slice(0, MAX_VISIBLE_FEATURES);

    const buyPackage = async () => {
      try{
          setGettingStarted(true);

          const redirectUrl = `${window.location.protocol}//${window.location.host}/stripe/success`;

          const res = await getUserBillingInformation({
              packageId: plan.plan_id,
              pricingId: plan.price_id,
              redirectUrl: redirectUrl
          });

          if (res && res.success && res.data){
              const billingProcess = res.data.billing_process;
              const paymentLink = res.data.payment_link;

              if (billingProcess === BILLING_TYPE_NEW){
                  if (paymentLink){
                      window.location.href = paymentLink;
                      return;
                  }

                  setShowCautionAlert(true);
              }
          }

          setGettingStarted(false);
      }catch (err){
          console.log(err);
          setGettingStarted(false);
      }
    };

    return(
        <Grid className={classes.gridItem} item>
            {
                plan.current_plan ?
                    <div className={classes.trapezium}>
                        Your Current Plan
                    </div> :
                    null
            }

            <Card className={`${classes.card} ${plan.current_plan ? ' currentPlan': ''}`}>
                {
                    plan.custom ?
                        <div className={classes.ribbon}>
                            <Typography variant="caption" style={{height: 'unset !important'}}>Only for you</Typography>
                        </div> :
                        null
                }

                <CardContent>
                    <Typography variant={'h6'} gutterBottom style={{height: 'unset !important'}}>
                        {plan.title}
                    </Typography>
                    <Typography className={classes.price} style={{height: 'unset !important'}}>
                        ${Utils.fixDecimal(plan.price)}{' '}
                        {plan.price_type === 'CUSTOM' && plan.validity && (
                            <span className={classes.validity}>/ {plan.validity} days</span>
                        )}
                    </Typography>
                    <Typography className={classes.description} style={{height: 'unset !important'}}>
                        {plan.description}
                    </Typography>
                    <div className={classes.features}>
                        {
                            visibleFeatures.map((feature, idx) => (
                                <Typography key={idx} className={classes.feature} style={{height: 'unset !important'}}>
                                    {feature}
                                </Typography>
                            ))
                        }
                    </div>

                    {
                        plan.features.length > MAX_VISIBLE_FEATURES && (
                            <div className={classes.seeMore}>
                        <span className={classes.seeMoreButton} onClick={toggleShowAll}>
                            {showAll ? 'See less' : 'See more'}
                        </span>
                            </div>
                        )
                    }
                </CardContent>

                <Button
                    variant={'contained'}
                    color={'primary'}
                    className={classes.button}
                    fullWidth
                    onClick={buyPackage}
                    disabled={gettingStated}
                >
                    {gettingStated ? 'Getting Started...' : 'Select this Plan'}
                </Button>
            </Card>

            {
                showCautionAlert &&
                <PackageUpdateCaution
                    isOpen={showCautionAlert}
                    selectedPlan={plan}
                    onClose={()=>{ setShowCautionAlert(false); }}
                    onCloseUpdatePlanModal={()=>{
                        dispatch(fetchDetails());
                    }}
                />
            }
        </Grid>
    );
};

export default PackageItem;